module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNq8VgsNwyAQJVOABCRUAhIqASl1UAlIqAQkTEIlIKHrknfJ26UwthQueUl7fXfcD6gxbRJOHArB3CgJThfggO4vWWEsEdoTTzgVOaCzlGGCbVWiKsN2IuN5J94OXQaHbWItconMk+OMb464DjrmeMp0rdXZkxNPZbgSC44s7mv9CRSNU04iRSucqBZ3xClO2KaymFQZEsC6SUW/1dLNgKV3GU+ruAstYi/sP0qTLhoUyXlJFmXDg/L2ORs1YjvVX6IxX5rMPEcjLChG2bpbk9qEH9k9zADpXqL5hibHQpPDL2OquWvrmA7baKWjwt11VHQ/7Lof190vnCFX5pBLv/W3ZW4xfAkwAPwE0Nwpfx2EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/App_SettingsIcon.png
// module id = MXF1
// module chunks = 1